"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var EurotripsLogo = function EurotripsLogo(_ref) {
  var name = _ref.name,
    fill = _ref.fill,
    className = _ref.className,
    title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    id: "_\u0421\u043B\u043E\u0439_2",
    className: "icon ".concat(className, " d8-svg-").concat(name),
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 299.28 210.53"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title || 'Eurotrips Logo'), /*#__PURE__*/_react["default"].createElement("g", {
    id: "_\u0421\u043B\u043E\u0439_1-2"
  }, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    style: {
      fill: fill
    },
    d: "M60.31,175.16v19.73c0,1.91-.38,3.52-1.1,4.87-.73,1.35-1.76,2.39-3.1,3.11l.31,.56-.31-.55c-1.33,.73-3,1.11-4.95,1.11s-3.59-.38-4.94-1.11c-1.37-.73-2.39-1.76-3.11-3.11-.7-1.31-1.07-2.9-1.1-4.74v-19.87h-7.02v19.96c0,3.03,.68,5.74,2.04,8.06,1.37,2.32,3.28,4.12,5.72,5.42,2.44,1.29,5.23,1.93,8.41,1.93s6.01-.62,8.44-1.93c2.41-1.29,4.33-3.09,5.69-5.42,1.37-2.33,2.04-5.03,2.04-8.06v-19.96h-7.02Z"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    style: {
      fill: fill
    },
    points: "9.19 195.56 28.91 195.56 28.91 189.4 9.19 189.4 7.95 181.51 29.97 181.51 29.97 175.16 0 175.16 .11 175.9 2.74 192.47 .11 209.02 0 209.76 30.19 209.76 30.19 203.42 7.95 203.42 9.19 195.56"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    style: {
      fill: fill
    },
    d: "M299.26,199.19c0-1.93-.38-3.57-1.19-4.89-.83-1.33-2.17-2.35-3.96-3.07-1.77-.73-4.16-1.3-7.14-1.72l-7.19-1.03-.09,.62,.09-.64c-2.35-.33-3.89-.8-4.71-1.35-.77-.51-1.15-1.22-1.15-2.23,0-1.28,.63-2.31,2.08-3.11,1.48-.82,3.51-1.26,6.14-1.26,1.85,0,3.42,.24,4.74,.7l.22-.6-.04,.11-.18,.5c1.33,.46,2.35,1.1,3.1,1.88,.73,.77,1.16,1.67,1.29,2.73l.06,.56h7.11l-.04-.68c-.13-2.28-.92-4.28-2.36-5.99-1.44-1.7-3.34-3-5.71-3.91-2.37-.93-5.03-1.39-8.08-1.39s-5.72,.42-8.03,1.28c-2.31,.85-4.14,2.07-5.44,3.69-1.3,1.63-1.95,3.56-1.95,5.75,0,2.88,.96,5.16,2.94,6.78,1.93,1.59,4.97,2.63,8.97,3.16l7.11,.94c2.59,.32,4.25,.8,5.12,1.38,.79,.52,1.2,1.3,1.2,2.42,0,1.33-.68,2.41-2.25,3.27-1.59,.87-3.82,1.33-6.71,1.33-1.93,0-3.6-.27-5.04-.79-1.44-.52-2.57-1.25-3.41-2.18-.83-.92-1.33-1.99-1.48-3.19l-.08-.55h-6.34s-.75-.01-.75-.01l.04,.68c.13,2.44,.93,4.58,2.42,6.42,1.48,1.82,3.48,3.24,5.97,4.25,2.5,1.01,5.42,1.51,8.59,1.51s5.95-.45,8.36-1.37c2.41-.9,4.31-2.22,5.69-3.94,1.38-1.72,2.07-3.75,2.07-6.04h-.01Z"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    style: {
      fill: fill
    },
    points: "147.03 175.16 146.39 175.16 146.39 175.8 146.39 180.95 146.39 181.59 147.03 181.59 160.14 181.59 160.14 209.13 160.14 209.76 160.77 209.76 166.63 209.76 167.27 209.76 167.27 209.13 167.27 181.59 180.38 181.59 181.02 181.59 181.02 180.95 181.02 175.8 181.02 175.16 180.38 175.16 147.03 175.16"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    style: {
      fill: fill
    },
    points: "221.31 175.16 220.67 175.16 220.67 175.8 220.67 209.13 220.67 209.76 221.31 209.76 226.61 209.76 227.25 209.76 227.25 209.13 227.25 175.8 227.25 175.16 226.61 175.16 221.31 175.16"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    style: {
      fill: fill
    },
    d: "M205.06,196.26c1.41-.2,2.73-.59,3.92-1.15,1.88-.89,3.36-2.13,4.43-3.74,1.07-1.61,1.61-3.41,1.61-5.52s-.54-4.01-1.61-5.61c-1.07-1.61-2.57-2.84-4.43-3.74-1.88-.89-4.05-1.33-6.48-1.33h-18.98v34.59h7.2v-13.33h5.83l11.12,13.1,.19,.23h8.77l-.91-1.06-10.66-12.45Zm7.83-5.23h.03s-.03,.01-.03,.01h0Zm-22.16-.85v-8.67h11.24c1.89,0,3.29,.42,4.3,1.17,.97,.75,1.48,1.8,1.48,3.16s-.5,2.37-1.48,3.14h-.01c-1.01,.78-2.41,1.2-4.29,1.2h-11.24Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    style: {
      fill: fill
    },
    d: "M262.82,180.5c-1.05-1.69-2.54-3.01-4.44-3.94-1.91-.94-4.15-1.39-6.69-1.39h-18.12v34.59h7.1v-12.27h11.04c2.54,0,4.79-.46,6.69-1.4,1.9-.93,3.4-2.24,4.44-3.94,1.05-1.7,1.57-3.65,1.57-5.83s-.52-4.12-1.57-5.83h-.02Zm-7.09,9.36h0c-.98,.83-2.39,1.3-4.28,1.3h-10.81v-9.64h10.81c1.89,0,3.29,.46,4.28,1.31,.97,.84,1.48,1.99,1.48,3.52s-.51,2.68-1.48,3.51Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    style: {
      fill: fill
    },
    d: "M136.77,176.68h0c-2.96-1.53-6.36-2.27-10.21-2.27s-7.25,.74-10.21,2.26c-2.95,1.52-5.26,3.64-6.91,6.35-1.66,2.73-2.48,5.88-2.48,9.44s.82,6.72,2.48,9.44c1.65,2.72,3.96,4.83,6.91,6.35,2.95,1.52,6.36,2.26,10.21,2.26s7.25-.74,10.21-2.25h0c2.95-1.51,5.26-3.62,6.91-6.34,1.66-2.73,2.48-5.88,2.48-9.44s-.82-6.72-2.48-9.44c-1.66-2.72-3.96-4.83-6.91-6.35Zm.68,21.92c-1.01,1.72-2.42,3.04-4.25,3.97-1.84,.93-4.03,1.4-6.62,1.4s-4.76-.48-6.61-1.4c-1.85-.93-3.27-2.26-4.28-3.97l-.55,.32h0s.55-.33,.55-.33c-1.01-1.71-1.52-3.75-1.52-6.14s.52-4.41,1.52-6.12c1.01-1.72,2.43-3.03,4.28-3.97,1.85-.93,4.01-1.4,6.61-1.4s4.8,.49,6.62,1.4c1.84,.93,3.25,2.26,4.25,3.97l.55-.32-.08,.05-.47,.28c1.01,1.71,1.52,3.74,1.52,6.12s-.52,4.42-1.52,6.13Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    style: {
      fill: fill
    },
    d: "M95.16,196.26c1.41-.2,2.72-.59,3.92-1.15,1.88-.89,3.36-2.13,4.43-3.74,1.07-1.61,1.61-3.41,1.61-5.52s-.54-4.01-1.61-5.61c-1.07-1.61-2.57-2.84-4.43-3.74-1.88-.89-4.05-1.33-6.48-1.33h-18.98v34.59h7.2v-13.33h5.83l11.12,13.1,.19,.23h8.77l-.91-1.06-10.66-12.45Zm-14.34-6.07v-8.67h11.24c1.89,0,3.29,.42,4.3,1.17,.98,.74,1.48,1.8,1.48,3.16s-.5,2.37-1.48,3.14c-1.01,.78-2.41,1.2-4.3,1.2h-11.24Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    style: {
      fill: fill
    },
    d: "M57.97,21.92l18.68,9.6-.58,5.68-17.44-8.97-.73,4.68c-.42,3.23,1.16,6.43,4.03,8.09l21.67,12.4c.13,.06,.28,.12,.42,.22l2.22,1.29,.71,.41,5.67,3.24c.19,.1,2.08,1.15,5.12,2.92l2.53,1.44v.03c1.18,.7,2.47,1.47,3.85,2.31,3.79,1.89,7.14,2.84,9.49,2.65,.28-.04,.54-.1,.8-.15,1.31-13.44,.39-27.7-23.67-41.66L54.75,5.26l-.75,8.52c-.42,3.27,1.13,6.46,3.98,8.13Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    style: {
      fill: fill
    },
    d: "M207.9,123.98c-.26-5.72-4.25-10.59-9.79-12.02-2.89-.74-5.78-1.55-8.65-2.52l-.6,.9c-1.77,2.66-4.72,4.13-7.75,4.13h.02c-1.36,.01-2.74-.29-4.03-.92l-23.94-11.21-17.37,13.73,8.54,4.96c1.87,.95,2.34,1.37,7.32,2.22,18.1,2.65,36.96,2.91,56.26,.83,0-.04,0-.07,0-.11Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    style: {
      fill: fill
    },
    d: "M119.85,66.56c.58-.15,1.16-.31,1.76-.47,5.15-1.38,10.48-2.81,16.34-2.36h.15c.73,.12,1.42,.26,2.12,.44,3.34-30-23.99-44.7-62.02-64.18l-1.54,11.82,16.75,9.7c25.71,14.91,27.59,30.93,26.45,45.04Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    style: {
      fill: fill
    },
    d: "M133.44,69.06l22.38,28.56,23.54,11.13c1.77,.87,3.86,.32,4.99-1.22-.7-.29-1.39-.6-2.08-.92-6.15-2.94-15.18-7.94-22.48-12.13l-12.45-19.43c-3.15-3.56-6.38-5.54-9.9-6.04-1.35-.1-2.68-.07-4.01,.04Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    style: {
      fill: fill
    },
    d: "M149.35,98.58h0s-21.84-28.52-21.84-28.52c-1.51,.35-3.02,.76-4.56,1.16-1.26,.33-2.52,.67-3.82,.99-.65,3.53-1.76,6.97-3.31,10.27l-.73,1.53c-1.28,2.23-3.34,3.81-5.8,4.48-.83,.22-1.67,.33-2.5,.33-1.65,0-3.29-.44-4.76-1.29l-13.9-8.26-11.38-6.57c-.12,.29-.25,.58-.36,.87-.87,2.09-1.78,4.23-2.79,6.38l57.22,33.26,18.52-14.63Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    style: {
      fill: fill
    },
    d: "M90.8,74.66l13.9,8.26h.03c1.99,1.16,4.56,.49,5.75-1.48l.57-1.22c1.04-2.25,1.86-4.58,2.44-6.95-4.09,.15-8.65-1.67-11.83-3.26l-.19-.1c-2.42-1.47-4.57-2.73-6.33-3.77l-16.22-9.29s0,0,0,.01l-16.06-9.2-.3,4.84c-.42,3.3,1.16,6.5,4.02,8.16l7.73,4.46s0,.01,0,.02l16.51,9.53Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    style: {
      fill: fill
    },
    d: "M207.66,129.34c-8.36,.87-16.64,1.31-24.82,1.31-4.64,0-25.82-1.85-27.31-2.02-11.74-1.7-17.32-5.24-17.32-5.24-22.3-12.96-44.6-25.92-66.9-38.88-.07,.13-.15,.26-.22,.39-.08,.13-.15,.26-.22,.39-2.28,3.96-4.43,7.69-4.9,11.76,.01,.29,.1,.52,.15,.61,10.42,6.78,20.45,12.19,31.05,17.9,6.66,3.59,30.61,17.67,30.61,17.67,0,0,10.35,5.26,25.25,6.12,13.3,1.55,32.7,.53,34.67,.4,4.8-.32,9.48-.64,14.11-1.15,2.14-.24,3.97-1.69,4.62-3.74,.57-1.8,.99-3.66,1.24-5.54Z"
  }))));
};
EurotripsLogo.propTypes = {
  name: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  fill: _propTypes["default"].string,
  className: _propTypes["default"].string
};
EurotripsLogo.defaultProps = {
  fill: '#ffffff',
  className: ''
};
var _default = exports["default"] = EurotripsLogo;